import { useTranslation } from 'libs/i18n'
import { useDevice, usePagination } from 'shared/hooks'
import { Table2 } from 'shared/components'
import { Pagination } from 'shared/atoms'
import { getCardTableStyles } from 'styles/table'
import { Payout } from 'features/payouts/molecules/Payout/Payout'
import type { Option } from 'shared/components/ContextMenu/types'
import type { Select } from '@table-library/react-table-library/select'
import type { PayoutItem, PayoutsRes } from 'features/payouts/types/payouts.types'
import { useColumns } from '../hooks/useColumns'

type TableSectionProps = {
	payouts: PayoutsRes
	select: Select
	menuOptions: Option[]
	onOpen: (payout: PayoutItem) => void
}

export const TableSection = ({ payouts, select, menuOptions, onOpen }: TableSectionProps) => {
	const { t } = useTranslation()
	const { isMobileOrTablet } = useDevice()
	const { handlePagination } = usePagination()
	const columns = useColumns({ menuOptions, onOpen })

	const results = payouts.data.results

	return (
		<>
			{isMobileOrTablet ? (
				<ul className="divide-y divide-border">
					{results.map((payout) => (
						<Payout key={payout.id} payout={payout} menuOptions={menuOptions} onOpen={onOpen} />
					))}
				</ul>
			) : (
				<Table2
					className="mb-0 px-0 py-0 lg:flex lg:min-h-0 lg:flex-1 lg:flex-col"
					columns={columns}
					data={{ nodes: results }}
					isLoading={false}
					select={select}
					customStyles={getCardTableStyles(columns, { clickableRows: false })}
				/>
			)}
			<div className="flex items-center justify-between gap-3 border-t border-border px-4 py-3 text-[11px] font-medium text-muted-foreground sm:px-5">
				<span>{t('{{ count }} payouts', { count: results.length })}</span>
				<Pagination
					prev={payouts.data.previous}
					next={payouts.data.next}
					onClick={handlePagination}
				/>
			</div>
		</>
	)
}
